// 通常版（白・アイボリーなど明るい背景用）。
// 背景が濃色の場合はモノクロ表示（白）で統一するルールのため、
// 濃色面に載せるときは lisse_rebranding_logo_on-dark.svg へ差し替える
// （Design Hub /lecheck-rebrand/logo.html · 2026-08-27 電通確認）。
import lisseLogo from '@/assets/img/logo/lisse_rebranding_logo.svg';

const Brand = {
  Lecheck: {
    key: 'lecheck',
    headColorClass: 'header-brand-ivory',
    logoColorClass: 'logo',
    logoAsset: lisseLogo,
    // 名称の体系は「Lisse + 法務AI + 機能名」。本プロダクトは契約書管理。
    // 焼き込みの確定形 SVG があるのは契約書レビューのみのため、
    // サービス名は確定仕様どおりテキストで仮当てする
    serviceName: '法務AI 契約書管理',
    loginUrlPath: '/login',
    title: 'Lisse法務AI 契約書管理',
    faviconFileName: 'static/favicon-lisse-32x32.png'
  }
};

export default Brand;
export const getBrandByKey = (key) => {
  return Object.values(Brand).find((brand) => brand.key === key);
};
